<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import preventiveMeasureVerificationAPI from "@/services/standards/preventiveMeasureVerification/preventiveMeasureVerificationAPI";
import preventionControlVerificationAPI from "@/services/standards/preventionControlVerification/preventionControlVerificationAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";

const RESULT_OPTIONS = ["Cumple", "Parcial", "No cumple"];

/**
 * 4.2.2 Verificación de las medidas de prevención y control.
 * Verifica las medidas de la ÚLTIMA versión de la matriz del 4.2.1 (reconectado). Cada medida se verifica
 * (resultado + fecha + evidencia) y se genera un informe branded firmable anclado a la matriz.
 */
export default {
  page: {
    title: "4.2.2 Verificación de las medidas de prevención y control",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Style, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      title: "4.2.2 Verificación de las medidas de prevención y control",
      items: [
        { text: "Estandares", href: "/forms/estandares" },
        { text: "4.2.2 Verificación de las medidas de prevención y control", active: true },
      ],
      resultOptions: RESULT_OPTIONS,
      matrix: null,
      rows: [],
      rowState: {},
      workflowStatus: "draft",
      signedAt: null,
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      // Soportes de verificación cargados anteriormente (flujo anterior).
      legacyVerifications: [],
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    verificationApi() {
      // document-id = matrix.id; DocumentActions llama pdfUrl(id)/sign(id,payload).
      return {
        pdfUrl: (id) => preventiveMeasureVerificationAPI.pdfUrl(id),
        sign: (id, payload) => preventiveMeasureVerificationAPI.sign(id, payload),
      };
    },
    resumen() {
      const c = { Cumple: 0, Parcial: 0, "No cumple": 0, "Sin verificar": 0 };
      this.rows.forEach((row) => {
        const res = (this.rowState[row.id] && this.rowState[row.id].verification_result) || null;
        c[res || "Sin verificar"]++;
      });
      const total = this.rows.length;
      const cumplimiento = total ? Math.round(((c.Cumple + 0.5 * c.Parcial) / total) * 100) : 0;
      return { ...c, total, cumplimiento };
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(46).then((r) => { this.itemData = r; }).catch((e) => console.log(e));
    },
    allowAccess() {
      try {
        const item = this.itemData;
        if (!item) return false;
        const c = this.$store.getters["company/getCompany"].company_classification_id || null;
        if (c === 1 && item.obligatory_UPA === 1) return true;
        if (c === 2 && item.obligatory_groupI === 1) return true;
        if (c === 3 && item.obligatory_groupII === 1) return true;
        if (c === 4 && item.obligatory_groupIII === 1) return true;
        return false;
      } catch (e) { console.log(e); return false; }
    },
    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null;
      if (!role) return false;
      if (roles) role = roles.includes(role);
      else role = [1, 2, 3, 4, 5, 6, 7, 8].includes(role);
      const permissions = this.$store.state.auth.info.permissions;
      const enabled = permissions.find((p) => p.name === name);
      return enabled && role ? true : false;
    },
    resultBadge(res) {
      return { Cumple: "badge-success", Parcial: "badge-warning", "No cumple": "badge-danger" }[res] || "badge-secondary";
    },
    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 46)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((e) => console.log(e));
    },
    changeItemStatus(itemStatus) {
      newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 46, status: itemStatus })
        .then(() => Swal.fire({ title: "¡Éxito!", text: "¡Estado del ítem actualizado!", icon: "success", confirmButtonClass: "btn btn-confirm mt-2" }))
        .catch((e) => { Swal.fire({ title: "¡ERROR!", text: "¡No se actualizó el estado!", icon: "error" }); console.log(e); });
    },

    getList() {
      preventiveMeasureVerificationAPI.measures(this.companyID)
        .then((response) => {
          this.matrix = (response && response.matrix) || null;
          this.rows = (response && response.rows) || [];
          this.workflowStatus = (response && response.workflow_status) || "draft";
          this.signedAt = (response && response.signed_at) || null;
          const state = {};
          this.rows.forEach((row) => {
            const v = row.verification || {};
            state[row.id] = {
              verification_date: v.verification_date || null,
              verification_result: v.verification_result || null,
              observations: v.observations || null,
              file: v.file || null,
              localFile: null,
              saving: false,
            };
          });
          this.rowState = state;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },

    onFileChange(rowId, event) {
      const files = event.target.files || [];
      this.rowState[rowId].localFile = files[0] || null;
    },
    getFileName(file) { return file ? String(file).split("/").pop() : ""; },
    gotoDigitalOcean(url) { if (url) window.open(url); },
    // Lista las medidas con soporte de verificación cargado anteriormente (read-only).
    getLegacyVerifications() {
      preventionControlVerificationAPI.getAllMeasures(this.companyID)
        .then((response) => {
          const data = (response && response.Prevention_control) || [];
          this.legacyVerifications = data.filter((m) => m.verification && m.verification.file);
        })
        .catch((e) => { console.log(e); });
    },

    async uploadEvidence(rowId) {
      const state = this.rowState[rowId];
      if (!state.localFile) return state.file;
      const base = process.env.VUE_APP_ENV === "development" ? "sst-dev" : "sst-prod";
      const path = `${base}/${this.nit}/4.2.2/${rowId}/${Date.now()}_${state.localFile.name}`;
      const ok = await uploadDocument(path, state.localFile);
      return ok ? `${process.env.VUE_APP_BUCKET}/${path}` : null;
    },

    async saveVerification(row) {
      if (this.isSigned) return;
      const state = this.rowState[row.id];
      if (!state.verification_date && !state.verification_result && !state.localFile && !state.file) {
        Swal.fire({ title: "¡Atención!", text: "Diligencia al menos un campo antes de guardar.", icon: "warning" });
        return;
      }
      state.saving = true;
      try {
        let fileUrl = state.file;
        if (state.localFile) {
          const uploaded = await this.uploadEvidence(row.id);
          if (!uploaded) { state.saving = false; Swal.fire("Error", "No se pudo subir el archivo.", "error"); return; }
          fileUrl = uploaded;
        }
        await preventiveMeasureVerificationAPI.upsert({
          preventive_measure_row_id: row.id,
          verification_date: state.verification_date,
          verification_result: state.verification_result,
          observations: state.observations,
          file: fileUrl,
        });
        state.file = fileUrl;
        state.localFile = null;
        newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 46, status: "Pendiente" }).catch(() => {});
        Swal.fire({ title: "¡Éxito!", text: "Verificación guardada.", icon: "success", timer: 1400, showConfirmButton: false });
      } catch (e) {
        console.log(e);
        Swal.fire("Error", "No se pudo guardar la verificación.", "error");
      } finally {
        state.saving = false;
      }
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
    goBack() { this.$router.go(-1); },
  },
  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getLegacyVerifications();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div v-if="!loading" class="col-lg-9">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <CheckModal>
                  <p class="text-justify">
                    Verificación de las medidas de prevención y control registradas en el ítem 4.2.1 (última versión de la
                    matriz). Por cada medida diligencia el resultado de la verificación (Cumple / Parcial / No cumple), la
                    fecha y la evidencia. La plataforma calcula el cumplimiento y genera el informe para su firma.
                  </p>
                </CheckModal>
              </div>
              <div class="form-row col-md-4 col-sm-12 pt-1">
                <b-form-group class="col-sm-12" label="Estado del ítem">
                  <b-form-select v-on:change="changeItemStatus(itemStatus)"
                    :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                    class="selectpicker form-control" v-model="itemStatus">
                    <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                    <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                    <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 El informe de verificación de esta versión ya fue firmado; las verificaciones quedan bloqueadas.
            </div>

            <hr />

            <div v-if="!matrix || !rows.length" class="text-center pt-3 text-muted">
              No hay medidas registradas en el ítem 4.2.1. Registra la matriz de medidas primero.
            </div>

            <div v-else>
              <p class="small text-muted">Matriz 4.2.1 · versión {{ matrix.version }}</p>
              <div v-for="row in rows" :key="row.id" class="card border mb-3">
                <div class="card-body py-2">
                  <div class="form-row">
                    <b-form-group class="col-md-3 px-2" label="Peligro">
                      <b-form-input :value="row.peligro" disabled size="sm" />
                    </b-form-group>
                    <b-form-group class="col-md-5 px-2" label="Medida de prevención y control">
                      <b-form-input :value="row.medida" disabled size="sm" />
                    </b-form-group>
                    <b-form-group class="col-md-3 px-2" label="Jerarquía">
                      <b-form-input :value="row.jerarquia" disabled size="sm" />
                    </b-form-group>
                    <b-form-group class="col-md-1 px-2" label="Avance">
                      <b-form-input :value="row.avance + '%'" disabled size="sm" />
                    </b-form-group>
                  </div>

                  <div class="form-row align-items-end bg-light rounded py-1">
                    <b-form-group class="col-md-3 px-2" label="Fecha de verificación">
                      <b-form-input type="date" :disabled="isSigned || !getRole('Crear') || !allowAccess()"
                        v-model="rowState[row.id].verification_date" size="sm" />
                    </b-form-group>
                    <b-form-group class="col-md-3 px-2" label="Resultado">
                      <b-form-select :disabled="isSigned || !getRole('Crear') || !allowAccess()"
                        v-model="rowState[row.id].verification_result" size="sm">
                        <b-form-select-option :value="null">Selecciona...</b-form-select-option>
                        <b-form-select-option v-for="opt in resultOptions" :key="opt" :value="opt">{{ opt }}</b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-4 px-2" label="Observaciones">
                      <b-form-input :disabled="isSigned || !getRole('Crear') || !allowAccess()"
                        v-model="rowState[row.id].observations" size="sm" />
                    </b-form-group>
                    <div class="col-md-2 px-2 pb-2">
                      <span class="badge" :class="resultBadge(rowState[row.id].verification_result)">
                        {{ rowState[row.id].verification_result || 'Sin verificar' }}
                      </span>
                    </div>
                  </div>

                  <div class="form-row align-items-end">
                    <b-form-group class="col-md-8 px-2" label="Evidencia (opcional)">
                      <div class="d-flex align-items-center">
                        <input type="file" :disabled="isSigned || !getRole('Crear') || !allowAccess()"
                          class="form-control form-control-sm"
                          accept=".doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.webp,image/*"
                          @change="onFileChange(row.id, $event)" />
                        <button v-if="rowState[row.id].file" type="button" class="btn btn-outline-primary btn-sm ml-2"
                          @click="gotoDigitalOcean(rowState[row.id].file)"><i class="bx bx-download"></i></button>
                      </div>
                      <small v-if="rowState[row.id].file" class="text-muted">Actual: {{ getFileName(rowState[row.id].file) }}</small>
                    </b-form-group>
                    <div class="col-md-4 px-2 d-flex align-items-end">
                      <button type="button" class="btn btn-primary btn-sm w-100 mb-2"
                        :disabled="rowState[row.id].saving || isSigned || !getRole('Crear') || !allowAccess()"
                        @click="saveVerification(row)">
                        <span v-if="rowState[row.id].saving"><b-spinner small></b-spinner></span>
                        <span v-else>Guardar verificación</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading && matrix" class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <h6 class="text-muted small mb-2">Resumen de verificación</h6>
            <p class="mb-1"><span class="badge badge-success">Cumple: {{ resumen.Cumple }}</span></p>
            <p class="mb-1"><span class="badge badge-warning">Parcial: {{ resumen.Parcial }}</span></p>
            <p class="mb-1"><span class="badge badge-danger">No cumple: {{ resumen["No cumple"] }}</span></p>
            <p class="mb-1"><span class="badge badge-secondary">Sin verificar: {{ resumen["Sin verificar"] }}</span></p>
            <p class="mb-2 small">Cumplimiento: <strong>{{ resumen.cumplimiento }}%</strong></p>
          </div>
        </div>
        <h6 class="text-muted small mb-1">Informe de verificación</h6>
        <DocumentActions
          :document-id="Number(matrix.id)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="verificationApi"
          document-title="Verificación de las Medidas de Prevención y Control"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>

    <!-- Soportes de verificación cargados anteriormente (flujo anterior) -->
    <div class="row" v-if="legacyVerifications.length">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-1">Documento diligenciado</h5>
            <p class="text-muted mb-3">Soportes de verificación cargados anteriormente.</p>
            <div class="table-responsive">
              <table class="table table-striped border-bottom">
                <thead>
                  <tr>
                    <th class="text-left">Medida</th>
                    <th class="text-center">Fecha de verificación</th>
                    <th class="text-center">Soporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="m in legacyVerifications" :key="m.id">
                    <td class="text-left align-middle">
                      {{ m.hazard_description || m.description_control || m.prevention_controlcol || ('Medida #' + m.id) }}
                    </td>
                    <td class="text-center align-middle">
                      {{ (m.verification && m.verification.verification_date) || '—' }}
                    </td>
                    <td class="text-center align-middle">
                      <button style="background-color: transparent !important; border: none;" type="button"
                        @click="gotoDigitalOcean(m.verification.file)" title="Descargar soporte cargado">
                        <i class="mdi mdi-cloud-download" style="font-size:1.3rem;"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal { background-color: transparent !important; border: none; }
</style>
